module.exports = __webpack_public_path__ + "img/sld_scb_11_t1_green.d760652c.svg";